import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import {
  changeServiceArgs,
  sendRequest
} from 'mt-react-common/modules/events/common/reducers/userNoticesSetReadForm';

const userNoticesSetReadFormRN = 'eventsModule.forms.userNoticesSetReadForm';

class NoticeSetReadOneButton extends Component {
  handleSetRead = (e, id) => {
    e.preventDefault();
    this.props.changeServiceArgs([id]);
    this.props.sendRequest();
  };

  render() {
    return (
      <a href="" onClick={e => this.handleSetRead(e, this.props.noticeId)}>
        {t('Отметить как прочитанное')}
      </a>
    );
  }
}

NoticeSetReadOneButton.propTypes = {
  noticeId: PropTypes.number.isRequired,

  changeServiceArgs: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  changeServiceArgs: args =>
    dispatch(changeServiceArgs(userNoticesSetReadFormRN, args)),
  sendRequest: () => dispatch(sendRequest(userNoticesSetReadFormRN))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NoticeSetReadOneButton);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Notifications/NotificationsList/ActionsButtons/NoticeSetReadOneButton.js